<div ngbAccordion id="urval-accordion" #acc="ngbAccordion" activeIds="header-tab" (panelChange)="tabToggle($event)" [destroyOnHide]="false"
  [ngbTooltip]="skipsAllParams() ? ('urval.does-not-apply'|translate) : ''" placement="top">
  <div ngbAccordionItem id="header-tab">
    <div ngbAccordionBody>
      <div class="row"
        [style.pointer-events]="skipsAllParams() ? 'none' : 'all'"
        [style.opacity]="skipsAllParams() ? '0.5' : ''">
        <div class="col-12">
          <div id="top-links">
            <button type="button" class="btn btn-outline-info rounded-circle" (click)="shareReport()"
              [ngbTooltip]="'urval.share-report'|translate" placement="bottom">
              <i class="fas fa-lg fa-share"></i>
            </button>
            <!--<button *ngIf="loggedIn" type="button" class="btn btn-outline-primary rounded-circle" (click)="saveUserReport()"
            [ngbTooltip]="'urval.save-report'|translate" placement="bottom">
            <i class="fas fa-lg fa-save"></i>
          </button>-->
          <button type="button" class="btn btn-outline-secondary rounded-circle" (click)="open(urvalModal)"
            [ngbTooltip]="'urval.list'|translate" placement="bottom">
            <i class="fas fa-lg fa-list-ul"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary rounded-circle" (click)="cleanParameters()"
            [ngbTooltip]="'urval.clear'|translate" placement="bottom">
            <i class="fas fa-lg fa-trash-alt"></i>
          </button>
        </div>
      </div>
      <div class="col-12">
        <h2 id="urval-header" class="mb-3 text-center">{{ 'urval.header'|translate }}</h2>
      </div>
      <div class="col-12">
        <div class="form-check ms-1">
          <input type="checkbox" class="form-check-input"
            id="saveFiltersForAllReports" value="saveFiltersForAllReports"
            [(ngModel)]="saveFiltersForAllReports"
            (change)="changedSaveForAllReports.emit(saveFiltersForAllReports)">
            <label class="form-check-label" for="saveFiltersForAllReports">
              {{ 'urval.save-for-all'|translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (showThisParam('startdat') && showThisParam('stopdat')) {
    <div ngbAccordionItem="1" id="period-tab" [collapsed]="true">
      <div ngbAccordionHeader>
        <button ngbAccordionButton><h5>{{'urval.period.header'|translate}}</h5></button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div id="PeriodFrom" class="mb-3 me-2">
              <label>{{'urval.period.from'|translate}}</label>
              <div class="row">
                <div class="col-5 pe-0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text px-2" for="startYear">{{'urval.period.year'|translate}}</label>
                    </div>
                    <select class="form-select form-select-sm no-caret px-2" id="startYear" [(ngModel)]="startYearData.data" (change)="periodSelectChange()">
                      @for (year of startYears; track year) {
                        <option value="{{year}}">{{year}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-7 ps-0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text px-2" for="startMonth">{{'urval.period.month'|translate}}</label>
                    </div>
                    <select class="form-select form-select-sm no-caret px-2" id="startMonth" [(ngModel)]="startMonthData.data" (change)="periodSelectChange()">
                      @for (month of startMonths; track month) {
                        <option value="{{month.key}}">{{month.value}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div id="PeriodTo" class="mb-3 me-2">
              <label>{{'urval.period.to'|translate}}</label>
              <div class="row">
                <div class="col-5 pe-0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text px-2" for="stopYear">{{'urval.period.year'|translate}}</label>
                    </div>
                    <select class="form-select form-select-sm no-caret px-2" id="stopYear" [(ngModel)]="stopYearData.data" (change)="periodSelectChange()">
                      @for (year of stopYears; track year) {
                        <option value="{{year}}">{{year}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-7 ps-0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text px-2" for="stopMonth">{{'urval.period.month'|translate}}</label>
                    </div>
                    <select class="form-select form-select-sm no-caret px-2" id="stopMonth" [(ngModel)]="stopMonthData.data" (change)="periodSelectChange()">
                      @for (month of stopMonths; track month) {
                        <option value="{{month.key}}">{{month.value}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  }

  @if (showThisParam('kon')) {
    <div ngbAccordionItem id="kon-tab" [collapsed]="true">
      <div ngbAccordionHeader>
        <button ngbAccordionButton><h5>{{'urval.gender.header'|translate}}</h5></button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <treeview-single [paramData]="konParamData"
              [treeViewData]="konViewData"
            (updatedParam)="updateParam($event)"></treeview-single>
          </ng-template>
        </div>
      </div>
    </div>
  }

  @if (showThisParam('aldersgrupper')) {
    <div ngbAccordionItem id="alder-tab" [collapsed]="true">
      <div ngbAccordionHeader>
        <button ngbAccordionButton><h5>{{'urval.alder.header'|translate}}</h5></button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <treeview-single [paramData]="alderParamData"
              [treeViewData]="alderViewData"
            (updatedParam)="updateParam($event)"></treeview-single>
          </ng-template>
        </div>
      </div>
    </div>
  }

  @if (showThisParam('enhet') && enhetViewData?.serverData != null) {
    <div ngbAccordionItem id="enhet-tab" [collapsed]="true"> 
      <div ngbAccordionHeader>
        <button ngbAccordionButton><h5>{{'urval.enhet.header'|translate}}</h5></button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            @if (enhetViewData.serverData.length > 0) {
            <treeview-single [paramData]="enhetParamData"
              [treeViewData]="enhetViewData"
              [showFilter]="true"
            (updatedParam)="updateParam($event)"></treeview-single>
            }
            @else {
              <i>{{'urval.enhet.no-available'|translate}}</i>
            }
          </ng-template>
        </div>
      </div>
    </div>
  }

      <!-- IS 230524: "Folkbokföringskommun" tas bort tillfälligt, kommer tillbaka när "Verksamhet" försvunnit  (Sanna) -->
      <!-- IS 230815: "Folkbokföringskommun" tillbaka, men endast på rapporten "Täckningsgrad"  (Maria) -->
      @if (showThisParam('kommun')) {
        <div ngbAccordionItem id="kommun-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.kommun.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <treeview-single [paramData]="kommunParamData"
                  [treeViewData]="kommunViewData"
                  [showFilter]="true"
                (updatedParam)="updateParam($event)"></treeview-single>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('avlidenplats')) {
        <div ngbAccordionItem id="avlidenplats-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.avlidenplats.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <treeview-single [paramData]="avlidenplatsParamData"
                  [treeViewData]="avlidenplatsViewData"
                (updatedParam)="updateParam($event)"></treeview-single>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('vardAv')) {
        <div ngbAccordionItem id="vardAv-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.vard-av.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="form-default ps-2">
                  @for (vardAvParam of (vardAvParamDatas | async); track vardAvParam.name; let i = $index) {
                    <div>
                      <checkbox-item [text]="(vardAvViewDatas|async)[i]?.title" value="1"
                        [checked]="vardAvParam.data ? vardAvParam.data[0] : 0"
                      (clicked)="setVardAv($event, vardAvParam.name)"></checkbox-item>
                    </div>
                  }
                </div>
                <i class="text-muted" style="font-size:95%">{{'urval.vard-av.info'|translate}}</i>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('hemtjanst')) {
        <div ngbAccordionItem id="hemtjanst-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.hemtjanst.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <treeview-single [paramData]="hemtjanstParamData"
                  [treeViewData]="hemtjanstViewData"
                (updatedParam)="updateParam($event)"></treeview-single>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('vardtid')) {
        <div ngbAccordionItem id="vardtid-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.vardtid.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <treeview-single [paramData]="vardtidParamData"
                  [treeViewData]="vardtidViewData"
                (updatedParam)="updateParam($event)"></treeview-single>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('dodsfallVantat')) {
        <div ngbAccordionItem id="dodsfallvantat-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.dodsfall-vantat.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <treeview-single [paramData]="dodsfallVantatParamData"
                  [treeViewData]="dodsfallVantatViewData"
                (updatedParam)="updateParam($event)"></treeview-single>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('diagnosgrupp')) {
        <div ngbAccordionItem id="diagnos-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.diagnosgrupp.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="form-default ps-2">
                  @for (diagnosParam of (diagnosParamDatas | async); track diagnosParam.name; let i = $index) {
                    <div>
                      <checkbox-item [text]="(diagnosViewDatas|async)[i]?.title" value="1"
                        [checked]="diagnosParam.data ? diagnosParam.data[0] : 0"
                      (clicked)="setDiagnosGrupp($event, diagnosParam.name)"></checkbox-item>
                    </div>
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      }

      @if (showThisParam('externKonsult')) {
        <div ngbAccordionItem id="externKonsult-tab" [collapsed]="true">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><h5>{{'urval.extern-konsult.header'|translate}}</h5></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="form-default ps-2">
                  @for (extParam of (externKonsultParamDatas | async); track extParam.name; let i = $index) {
                    <div>
                      <checkbox-item [text]="(externKonsultViewDatas|async)[i]?.title" value="1"
                        [checked]="extParam.data ? extParam.data[0] : 0"
                      (clicked)="setExternKonsultGrupp($event, extParam.name)"></checkbox-item>
                    </div>
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      }

    </div>


    <ng-template #urvalModal let-c="close" let-d="dismiss">
      <div class="modal-header py-2">
        <h5 class="modal-title text-center">{{'urval.my-selections.header'|translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        @if (showThisParam('startdat')) {
          <display-param-text-data [paramData]="startdatData"></display-param-text-data>
        }
        @if (showThisParam('stopdat')) {
          <display-param-text-data [paramData]="stopdatData"></display-param-text-data>
        }
        @if (showThisParam('kon')) {
          <display-param-treeview-data [paramData]="konParamData" [treeViewData]="konViewData"></display-param-treeview-data>
        }
        @if (showThisParam('aldersgrupper')) {
          <display-param-treeview-data [paramData]="alderParamData" [treeViewData]="alderViewData"></display-param-treeview-data>
        }
        <!--<display-param-treeview-data [paramData]="covidParamData" [treeViewData]="covidViewData" *ngIf="showThisParam('covid')"></display-param-treeview-data>-->
        @if (showThisParam('enhet') && enhetViewData.serverData != null) {
          <display-param-treeview-data [paramData]="enhetParamData" [treeViewData]="enhetViewData"></display-param-treeview-data>
        }
        @if (showThisParam('kommun')) {
          <display-param-treeview-data [paramData]="kommunParamData" [treeViewData]="kommunViewData"></display-param-treeview-data>
        }
        @if (showThisParam('avlidenplats')) {
          <display-param-treeview-data [paramData]="avlidenplatsParamData" [treeViewData]="avlidenplatsViewData"></display-param-treeview-data>
        }
        @if (showThisParam('vardAv')) {
          <display-param-grouped-treeview-data [paramTitle]="'urval.vard-av.header'|translate"
          [paramDatas]="vardAvParamDatas | async" [treeViewDatas]="vardAvViewDatas | async"></display-param-grouped-treeview-data>
        }
        @if (showThisParam('hemtjanst')) {
          <display-param-treeview-data [paramData]="hemtjanstParamData" [treeViewData]="hemtjanstViewData"></display-param-treeview-data>
        }
        @if (showThisParam('vardtid')) {
          <display-param-treeview-data [paramData]="vardtidParamData" [treeViewData]="vardtidViewData"></display-param-treeview-data>
        }
        @if (showThisParam('dodsfallVantat')) {
          <display-param-treeview-data [paramData]="dodsfallVantatParamData" [treeViewData]="dodsfallVantatViewData"></display-param-treeview-data>
        }
        @if (showThisParam('diagnosgrupp')) {
          <display-param-grouped-treeview-data [paramTitle]="'urval.diagnosgrupp.header'|translate"
          [paramDatas]="diagnosParamDatas | async" [treeViewDatas]="diagnosViewDatas | async"></display-param-grouped-treeview-data>
        }
        @if (showThisParam('externKonsult')) {
          <display-param-grouped-treeview-data [paramTitle]="'urval.extern-konsult.header'|translate"
          [paramDatas]="externKonsultParamDatas | async" [treeViewDatas]="externKonsultViewDatas | async"></display-param-grouped-treeview-data>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'general.close'|translate}}</button>
      </div>
    </ng-template>


    <div id="print-params" hidden>
      <table class="table table-sm content-table">
        <thead><tr><th><h6>{{'urval.made-selections'|translate}}</h6></th></tr></thead>
        <tbody>
          <tr>
            <td>
              <parameter-list [textParamDatas]="textParamDatas | async"
                [treeParamDatas]="treeParamDatas | async"
                [treeViewDatas]="treeViewDatas | async"
                [vardAvParamDatas]="vardAvParamDatas | async"
                [vardAvViewDatas]="vardAvViewDatas | async"
                [diagnosParamDatas]="diagnosParamDatas | async"
                [diagnosViewDatas]="diagnosViewDatas | async"
                [externKonsultParamDatas]="externKonsultParamDatas | async"
              [externKonsultViewDatas]="externKonsultViewDatas | async"></parameter-list>
            </td>
          </tr>
        </tbody>
        <tfoot><tr><th>&ensp;</th></tr></tfoot>
      </table>
    </div>
